import { gql } from 'graphql-tag'

export const UPDATE_ADDRESS_HOURS = gql`
  mutation updateAddressHours($addressHoursInput: AddressHoursInput!) {
    updateAddressHours(addressHoursInput: $addressHoursInput) {
      enabled
      dayHours {
        dayOfWeek
        openTime
        closeTime
        isClosed
        openPeriods {
          open {
            day
            time
          }
          close {
            day
            time
          }
        }
      }
    }
  }
`
